import type { SuggestionInput } from './noteInstructions.types';

const LONG_NOTE_CHARS = 800;
const MAX_SUGGESTIONS = 3;

/** Deterministic composer suggestions from session state (no LLM). */
export const getInstructionSuggestions = ({ note, tasks }: SuggestionInput): string[] => {
  const hasTask = (type: string) => tasks.some((task) => task.type === type);
  const rules: Array<[boolean, string]> = [
    [note.length > LONG_NOTE_CHARS, 'Styttu nótuna'],
    [!hasTask('bloodtest'), 'Bættu við blóðprufubeiðni'],
    [!hasTask('radiology_request'), 'Bættu við röntgenbeiðni'],
    [!hasTask('patient_letter'), 'Skrifaðu samantektarbréf til sjúklings'],
    [!hasTask('booking'), 'Bættu við endurkomu eftir tvær vikur'],
  ];
  return rules
    .filter(([applies]) => applies)
    .map(([, label]) => label)
    .slice(0, MAX_SUGGESTIONS);
};
